import React, { ReactNode } from "react";

import {
  createReducer,
  createStore,
  Provider as RPProvider,
} from "react-principal";
import { persistkeys } from "../constants";
type ThemeNamed = "light" | "dark";
export type TEMPLATENAME = "01" | "02";
interface InitialState {
  theme: ThemeNamed;
  template: TEMPLATENAME;
}
const initialState: InitialState = {
  theme: "light",
  template: "01",
};

const SET_THEME = "SET_THEME";
const SET_TEMPLATE_NAME = "SET_TEMPLATE_NAME";

const reducer = createReducer({
  SET_THEME: (state, { payload: { theme } }) => ({
    ...state,
    theme,
  }),
  SET_TEMPLATE_NAME: (state, { payload: { template } }) => ({
    ...state,
    template,
  }),
});

const setTheme = (theme: ThemeNamed) => {
  return {
    type: SET_THEME,
    payload: { theme },
  };
};
const setTemplateName = (template: TEMPLATENAME) => {
  return {
    type: SET_TEMPLATE_NAME,
    payload: { template },
  };
};
const store = createStore<InitialState>({
  reducer,
  initialState,
  persistKey: persistkeys.theme,
  storage: window.localStorage,
  mapStateToPersist: ({ theme ,template}) => ({
    theme, // persist just theme
    template
  }),
});

const setThemePersistToState = () => store.setToState();

const ProviderTheme = ({ children }: { children: ReactNode }) => {
  return <RPProvider {...{ store }}>{children}</RPProvider>;
};

export {
  ProviderTheme,
  reducer,
  store,
  setTheme,
  setThemePersistToState,
  setTemplateName,
};
